import {
  arrayPrototype,
  getProxyRaw,
  isPrivateKey,
  isProxyRawKey
} from '@rehaje/shared'

import type { TRecord } from '@rehaje/shared'

export function createArrayProxy<T>(
  target: any[],
  mapping: (item: any) => T
): T[] {
  return new Proxy(target, {
    get(target: TRecord & TRecord[], key) {
      if (isProxyRawKey(key)) return getProxyRaw(target)
      const value = target[key]
      if (
        typeof key !== 'symbol' &&
        !isNaN(key) &&
        value !== undefined &&
        value !== null
      )
        return mapping(value)
      if (key === 'length') return target.map(mapping).filter(Boolean).length
      if (typeof value === 'function') {
        if (arrayPrototype[key as keyof typeof arrayPrototype]) return value
        return value.bind(target)
      }
      return value
    },
    set(target: TRecord & TRecord[], key, value) {
      if (isPrivateKey(key)) target[key] = value
      return true
    }
  }) as T[]
}
